import React, { useState } from 'react';
import { Search, ShoppingBag, User, Heart, ChevronRight, Star, ShieldCheck } from 'lucide-react';

export const EcommerceRealMockup: React.FC = () => {
  const [selectedProduct, setSelectedProduct] = useState(0);

  const products = [
    {
      id: 1,
      name: 'Aroma Lemon Serum',
      category: 'Lançamento',
      discount: '14% OFF',
      price: 'R$ 279,90',
      oldPrice: 'R$ 325,00',
      installments: 'até 6x de R$ 46,65 sem juros',
      image: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?auto=format&fit=crop&w=400&q=80'
    },
    {
      id: 2,
      name: 'Body Splash Botânico',
      category: 'Novo',
      discount: '17% OFF',
      price: 'R$ 189,90',
      oldPrice: 'R$ 229,00',
      installments: 'até 6x de R$ 31,65 sem juros',
      image: 'https://images.unsplash.com/photo-1612817288484-6f916006741a?auto=format&fit=crop&w=400&q=80'
    },
    {
      id: 3,
      name: 'Face Lemon Concentrado',
      category: 'Destaque',
      discount: '17% OFF',
      price: 'R$ 357,90',
      oldPrice: 'R$ 429,00',
      installments: 'até 6x de R$ 59,65 sem juros',
      image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?auto=format&fit=crop&w=400&q=80'
    },
    {
      id: 4,
      name: 'Herbal Hydration Cream',
      category: 'Edição Limitada',
      discount: '14% OFF',
      price: 'R$ 237,90',
      oldPrice: 'R$ 275,00',
      installments: 'até 6x de R$ 39,65 sem juros',
      image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=400&q=80'
    }
  ];

  return (
    <div className="w-full bg-[#FFFFFF] text-slate-900 font-sans border border-slate-200/90 rounded-3xl overflow-hidden shadow-2xl text-left">
      
      {/* 1. TOP ANNOUNCEMENT BAR */}
      <div className="bg-[#2E4731] text-white text-[11px] font-bold py-2 px-4 text-center tracking-wide">
         Entrega grátis para todo Brasil em compras acima de R$ 199,00
      </div>

      {/* 2. STORE HEADER (ESTILO SUÍS MOCKUP) */}
      <div className="bg-white border-b border-slate-100 px-6 py-4 flex items-center justify-between">
         <div className="flex items-center gap-8">
            <span className="font-heading font-black text-2xl tracking-tighter text-[#2E4731]">
               suís<span className="text-emerald-500 font-normal">.</span>
            </span>
            
            <nav className="hidden md:flex items-center gap-6 text-xs font-semibold text-slate-600">
               <span className="text-slate-900 font-bold hover:text-[#2E4731] cursor-pointer">Início</span>
               <span className="hover:text-[#2E4731] cursor-pointer">Catálogo</span>
               <span className="hover:text-[#2E4731] cursor-pointer">Entre em contato</span>
               <span className="hover:text-[#2E4731] cursor-pointer">Sobre nós</span>
               <span className="hover:text-[#2E4731] cursor-pointer">Termos de uso</span>
            </nav>
         </div>

         <div className="flex items-center gap-4 text-slate-700">
            <Search className="w-4 h-4 cursor-pointer hover:text-[#2E4731]" />
            <User className="w-4 h-4 cursor-pointer hover:text-[#2E4731]" />
            <div className="relative cursor-pointer">
               <ShoppingBag className="w-4 h-4 text-slate-900" />
               <span className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-[#2E4731] text-white rounded-full text-[9px] font-bold flex items-center justify-center">
                  2
               </span>
            </div>
         </div>
      </div>

      {/* 3. HERO BANNER (RECRIAÇÃO FIEL DA IMAGEM 1) */}
      <div className="bg-[#E8F0E6] p-8 md:p-12 relative overflow-hidden flex flex-col md:flex-row items-center justify-between gap-8">
         <div className="space-y-4 max-w-md relative z-10">
            <span className="text-[10px] font-black uppercase tracking-widest text-[#2E4731] bg-white/80 px-3 py-1 rounded-full border border-emerald-200">
               LANÇAMENTO 2026
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-black text-[#2E4731] leading-tight">
               Suas mãos hidratadas <br /> e muito cheirosas
            </h2>
            <p className="text-xs md:text-sm text-slate-700 font-medium leading-relaxed">
               Fórmula botânica exclusiva com óleo vegetal de limão siciliano e hidratação profunda por 24 horas.
            </p>
            <button className="bg-[#2E4731] hover:bg-[#1E3020] text-white text-xs font-bold px-6 py-3 rounded-xl transition-colors shadow-sm">
               Ver produto
            </button>
         </div>

         {/* Product Hero Image */}
         <div className="relative w-64 h-64 md:w-80 md:h-80 rounded-2xl overflow-hidden shadow-lg border border-emerald-900/10 shrink-0">
            <img 
               src="https://images.unsplash.com/photo-1596462502278-27bfdc403348?q=80&w=600&auto=format&fit=crop" 
               className="w-full h-full object-cover" 
               alt="Serum Botânico" 
            />
            <div className="absolute top-3 left-3 bg-white/90 backdrop-blur-sm text-[#2E4731] text-[9px] font-bold px-2.5 py-1 rounded-md border border-emerald-200">
               ⭐ 4.9 (480 avaliações)
            </div>
         </div>
      </div>

      {/* 4. SUB-BANNERS EM DUPLA */}
      <div className="p-6 md:p-8 bg-white grid grid-cols-1 md:grid-cols-2 gap-6 border-b border-slate-100">
         <div className="bg-[#F4F8F3] border border-slate-200/60 rounded-2xl p-6 flex items-center justify-between gap-4">
            <div className="space-y-2">
               <span className="text-[9px] font-bold uppercase text-slate-500">NOVO</span>
               <h3 className="text-xl font-black text-[#2E4731]">Body Splash®</h3>
               <button className="bg-[#2E4731] text-white text-[11px] font-bold px-4 py-2 rounded-lg">Ver produto</button>
            </div>
            <div className="w-24 h-24 rounded-xl overflow-hidden shadow-xs border border-slate-200">
               <img src="https://images.unsplash.com/photo-1612817288484-6f916006741a?q=80&w=200&auto=format&fit=crop" className="w-full h-full object-cover" alt="Body Splash" />
            </div>
         </div>

         <div className="bg-[#F4F8F3] border border-slate-200/60 rounded-2xl p-6 flex items-center justify-between gap-4">
            <div className="space-y-2">
               <span className="text-[9px] font-bold uppercase text-slate-500">DESTAQUE</span>
               <h3 className="text-xl font-black text-[#2E4731]">Face Lemon®</h3>
               <button className="bg-[#2E4731] text-white text-[11px] font-bold px-4 py-2 rounded-lg">Ver produto</button>
            </div>
            <div className="w-24 h-24 rounded-xl overflow-hidden shadow-xs border border-slate-200">
               <img src="https://images.unsplash.com/photo-1556228578-0d85b1a4d571?q=80&w=200&auto=format&fit=crop" className="w-full h-full object-cover" alt="Face Lemon" />
            </div>
         </div>
      </div>

      {/* 5. PRODUCT CATALOG GRID (RECRIAÇÃO DA IMAGEM 1) */}
      <div className="p-6 md:p-8 bg-white space-y-6">
         <div className="flex justify-between items-end border-b border-slate-100 pb-3">
            <div>
               <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400">ESCREVA SUA HISTÓRIA</span>
               <h3 className="text-2xl font-black text-slate-900">Produtos em Destaque</h3>
            </div>
            <span className="text-xs font-bold text-[#2E4731] hover:underline cursor-pointer flex items-center gap-1">
               Ver catálogo completo <ChevronRight className="w-3.5 h-3.5" />
            </span>
         </div>

         <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {products.map((item, idx) => (
               <div key={item.id} className="bg-white border border-slate-200/80 rounded-2xl p-3 space-y-3 hover:border-slate-300 transition-all flex flex-col justify-between group">
                  <div className="space-y-2">
                     {/* Product Photo with Badge */}
                     <div className="bg-[#F8FAFC] rounded-xl h-44 relative overflow-hidden flex items-center justify-center p-2">
                        <span className="absolute top-2 left-2 bg-[#2E4731] text-white text-[9px] font-black px-2 py-0.5 rounded">
                           {item.discount}
                        </span>
                        <img 
                           src={item.image} 
                           className="w-full h-full object-cover rounded-lg group-hover:scale-105 transition-transform duration-500" 
                           alt={item.name} 
                        />
                     </div>

                     {/* Thumbnail Selector Bar */}
                     <div className="flex gap-1 justify-center pt-1">
                        {[1, 2, 3].map(thumb => (
                           <div key={thumb} className={`w-6 h-6 rounded border ${thumb === 1 ? 'border-[#2E4731]' : 'border-slate-200'} overflow-hidden`}>
                              <img src={item.image} className="w-full h-full object-cover" alt="Thumb" />
                           </div>
                        ))}
                     </div>

                     {/* Info */}
                     <div>
                        <strong className="block text-xs font-bold text-slate-900 line-clamp-1">{item.name}</strong>
                        <div className="flex items-baseline gap-1.5 mt-1">
                           <strong className="text-xs font-black text-slate-900">{item.price}</strong>
                           <span className="text-[10px] text-slate-400 line-through">{item.oldPrice}</span>
                        </div>
                        <span className="text-[9px] text-slate-500 font-medium block mt-0.5">{item.installments}</span>
                     </div>
                  </div>

                  <button className="w-full bg-[#F4F8F3] hover:bg-[#2E4731] text-[#2E4731] hover:text-white font-bold text-[11px] py-2 rounded-xl border border-emerald-200 transition-colors">
                     Comprar agora
                  </button>
               </div>
            ))}
         </div>
      </div>

   </div>
  );
};
